import { Api } from '../base/api';
export class ApiService extends Api {
    constructor(cdn, baseUrl, options) {
        super(baseUrl, options);
        this.cdn = cdn;
    }
    async getProductList() {
        const data = await this.get('/product');
        return {
            total: data.total,
            items: data.items.map(item => (Object.assign(Object.assign({}, item), { image: this.resolveImageUrl(item.image) }))),
        };
    }
    resolveImageUrl(imagePath) {
        return imagePath.startsWith('http') ? imagePath : `${this.cdn}${imagePath}`;
    }
    postOrderRequest(orderData) {
        return this.post('/order', orderData).then((data) => data);
    }
}
